import { Heart } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";
import Ornamento from "./Ornamento";

export default function Rsvp({ datos, seccion, acciones }) {
  const rsvp = datos.rsvp || {};

  return (
    <section className="ba-seccion ba-rsvp" aria-label={seccion.titulo}>
      <div className="ba-seccion-interior">
        <EncabezadoSeccion p="ba" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="ba-titulo-rsvp" />
        <Reveal delay={0.1}>
          <div className="ba-rsvp-ornamento">
            <Ornamento />
          </div>
          {rsvp.mensaje && <p className="ba-rsvp-mensaje">{rsvp.mensaje}</p>}
          {rsvp.fechaLimite && <p className="ba-rsvp-limite">{rsvp.fechaLimite}</p>}
          <button
            type="button"
            className="ba-boton ba-boton--claro"
            onClick={() => acciones?.onConfirmarAsistencia?.()}
            data-testid="ba-boton-rsvp"
          >
            <Heart strokeWidth={1.5} />
            {rsvp.textoBoton || "Confirmar asistencia"}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
